import React from 'react';

import {
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Checkbox,
} from '@mui/material';

/**
 * TableBaseColumnType
 */
export interface TableBaseColumnType {
  /** ID */
  id: string;
  /** ラベル */
  label: string;
  /** 最小幅 */
  minWidth?: number;
  /** 幅 */
  width?: number,
  /** 揃え */
  align?: 'right';
}

/**
 * TableBaseRowType
 */
export interface TableBaseRowType {
  [key: string]: string
}

/**
 * ボディプロパティ
 */
export interface BodyProps {
  /** Rows */
  tableRows: TableBaseRowType[];
  /** ページ */
  page: number,
  /** ページ当たりのrows */
  rowsPerPage: number,
  /** columns */
  columns: TableBaseColumnType[];
  /** アクション */
  actions: {
    /** アイコン */
    icon: JSX.Element;
    /** アクション */
    action: (r: TableBaseRowType) => void;
    /** タイトル */
    title: string,
    /** 無効か */
    disabled?: (r: TableBaseRowType) => boolean,
  }[];
  /** チェック */
  onCheck?: (checked: boolean, name: string) => void;
  /** ホバー */
  hover?: boolean
  /** 行 */
  onRowClick?: (row: TableBaseRowType) => void;
}

const Body: React.FC<BodyProps> = ({
  tableRows,
  page,
  rowsPerPage,
  columns,
  actions,
  onCheck,
  hover,
  onRowClick,
}) => {
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableRows.length) : 0;
  return (
    <TableBody>
      {(rowsPerPage > 0
        ? tableRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : tableRows
      ).map((row, index) => {
        const actionComponents = [];
        for (let i = 0; i < actions.length; i += 1) {
          const act = actions[i];
          actionComponents.push(
            <Tooltip title={actions[i].title} key={`tooltip-${i}-${row.name}`}>
              <span>
                <IconButton
                  onClick={() => actions[i].action(row)}
                  disabled={act.disabled ? act.disabled(row) : false}
                >
                  {actions[i].icon}
                </IconButton>
              </span>
            </Tooltip>,
          );
        }
        return (
          <TableRow
            // eslint-disable-next-line react/no-array-index-key
            key={`row-${index}`}
            hover={hover}
            style={{ backgroundColor: row.backgroundColor }}
          >
            {onCheck && (
              <TableCell
                key={`checkbox-${row.id}`}
                align="center"
                style={{ width: '24px' }}
              >
                <Checkbox
                  color="primary"
                  checked={row.checked === 'checked'}
                  onChange={(e) => onCheck(e.target.checked, row.id)}
                />
              </TableCell>
            )}
            {columns.map((column) => (
              <TableCell
                key={`cell-${row.id}-${column.id}`}
                align={column.align}
                style={{ minWidth: column.minWidth, fontWeight: row.fontWeight }}
                onClick={onRowClick && (() => onRowClick(row))}
              >
                {row[column.id]}
              </TableCell>
            ))}
            {actionComponents.length > 0 && (
              <TableCell key={`actions-${row.id}`} align="center">
                {actionComponents}
              </TableCell>
            )}
          </TableRow>
        );
      })}
      {emptyRows > 0 && (
        <TableRow style={{ height: 53 * emptyRows }}>
          <TableCell colSpan={6} />
        </TableRow>
      )}
    </TableBody>
  );
};

export default Body;
